// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__nHmAz","message":"NotFound_message__d70mL","link":"NotFound_link__9fj+x"};